import { TitleFilterState } from './title.types';

// 0 = All option
export const getDefaultTitleFilter = (): TitleFilterState => ({
  title: '',
});
export const defaultTitleFilter = getDefaultTitleFilter();
